// GA4 Measurement ID — verify this matches the `G-…` ID in your GA4 property
// (Data Streams → Web → Measurement ID). Update here and in public/index.html.
const MEASUREMENT_ID = 'G-GVLJJR0VZK';

function gtag(...args) {
  if (typeof window.gtag === 'function') window.gtag(...args);
}

// ─── Navigation ────────────────────────────────────────────────────────────
// Event: navigation_click
// Fired when any nav link (desktop or mobile) is clicked.
// Params:
//   nav_label       — visible text of the clicked link (e.g. "Trendline IQ")
//   nav_destination — href of the link (e.g. "/trendline-iq")
//   nav_type        — "desktop_nav" | "mobile_nav"
export function trackNavClick({ label, destination, nav_type = 'desktop_nav' }) {
  gtag('event', 'navigation_click', {
    nav_label: String(label).slice(0, 100),
    nav_destination: String(destination).slice(0, 100),
    nav_type,
  });
}

// ─── Library filters ───────────────────────────────────────────────────────
// Event: filter_applied
// Fired when a filter facet chip is toggled on.
// Params:
//   filter_group  — facet group key (e.g. "categories", "platform", "style")
//   filter_value  — the facet ID that was toggled (e.g. "market-iq")
//   result_count  — visible product count after the filter takes effect
export function trackFilterApplied({ filter_group, filter_value, result_count }) {
  gtag('event', 'filter_applied', {
    filter_group: String(filter_group).slice(0, 40),
    filter_value: String(filter_value).slice(0, 100),
    result_count: Number(result_count),
  });
}

// Event: filter_cleared
// Fired when an entire facet group is cleared (e.g. "Clear" next to a group).
// Params:
//   filter_group — the facet group that was cleared
export function trackFilterCleared({ filter_group }) {
  gtag('event', 'filter_cleared', {
    filter_group: String(filter_group).slice(0, 40),
  });
}

// Event: filter_reset
// Fired when the "Reset Filters" button clears all active facets at once.
export function trackFilterReset() {
  gtag('event', 'filter_reset');
}

// ─── Copy to clipboard ─────────────────────────────────────────────────────
// Event: copy_code
// Fired when a user copies text from a <pre> or <code> element.
// Params:
//   content_snippet — first 120 characters of the copied text (no PII trimming needed
//                     for code blocks, but kept short to stay within GA4 limits)
export function trackCopyCode({ content_snippet = '' }) {
  gtag('event', 'copy_code', {
    content_snippet: String(content_snippet).slice(0, 120),
  });
}

// ─── Scroll depth ──────────────────────────────────────────────────────────
// Event: scroll_depth_reached
// Fired once per page load at each threshold (25, 50, 75, 100).
// GA4's built-in scroll event only fires at 90% — this gives finer breakpoints.
// Params:
//   percent_scrolled — 25 | 50 | 75 | 100
//   page_path        — window.location.pathname at time of fire
//   page_title       — document.title at time of fire
export function trackScrollDepth({ percent_scrolled, page_path, page_title }) {
  gtag('event', 'scroll_depth_reached', {
    percent_scrolled: Number(percent_scrolled),
    page_path: String(page_path).slice(0, 100),
    page_title: String(page_title).slice(0, 100),
  });
}

export { MEASUREMENT_ID };
